import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import { Game, Firebase } from '../../../../Core'

import * as MapSelectors from '../../map.selectors'
import * as MapActions from '../../map.actions'
import * as PhaseSelectors from '../../../Phases/phases.selectors'
import * as indicatorsSelectors from '../../../Indicators/indicators.selectors'

import TilePopup from './TilePopup'

const mapDispatchToProps = (dispatch) => ({
  clearAllPopups: bindActionCreators(Game.actions.clearAllPopups, dispatch),
  addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
  setDisplayingCard: bindActionCreators(MapActions.setDisplayingCard, dispatch),
})

const mapStateToProps = (state) => ({
  position: Game.selectors.getCursorPosition(state),
  buildings: MapSelectors.getBuildings(state),
  selectedBuilding: MapSelectors.getBuildingSelected(state),
  displayingBuildingCard: MapSelectors.getDisplayingBuildingCard(state),
  selectedTile: MapSelectors.getSelectedTile(state),
  currentPhase: PhaseSelectors.getCurrentPhase(state),
  visitorMap: MapSelectors.getVisitorMap(state),
  userMap: MapSelectors.getUserMap(state),
  types: MapSelectors.getBuildingTypes(state),
  indicators: indicatorsSelectors.getStoryLineIndicators(state),
  playerList: Firebase.selectors.getPlayerList(state),
  groupData: Firebase.selectors.getGroupData(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TilePopup))
